// extracted by mini-css-extract-plugin
export default {"root":"dHwu5A","text":"A7b5zq"};